export default __webpack_public_path__ + "static/media/Ballroll_00343.b8960311.png";